import React from 'react';
import ProviderCustomer from 'components/Tvendo/Article/Operations/ProviderCustomer/List';

export default function () {
  return <ProviderCustomer />;
}
